type Row = Record<string, any>

const toComparableNumber = (value: unknown) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export const byNumber = (key: string) => (a: Row, b: Row) =>
  toComparableNumber(a[key]) - toComparableNumber(b[key])

export const byString = (key: string) => (a: Row, b: Row) =>
  String(a[key] ?? "").localeCompare(String(b[key] ?? ""))
